import CompleteRegisterFormFiles from './CompleteRegisterFormFiles/CompleteRegisterFormFiles'
import CompleteRegisterInfoForm from './CompleteRegisterInfoForm/CompleteRegisterInfoForm'
import ConfirmSellerRolStep from './ConfirmSellerRolStep/ConfirmSellerRolStep'
import RegisterCompleteStepChanger from './RegisterCompleteStepChanger/RegisterCompleteStepChanger'

export {
  RegisterCompleteStepChanger,
  ConfirmSellerRolStep,
  CompleteRegisterInfoForm,
  CompleteRegisterFormFiles
}
